(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-own-journey"] && !Shopify.designMode) return;
  try {
    
function toggleSelection(el) {
  el.classList.toggle('selected');
  const selected = document.querySelectorAll('.location-card.selected');
  const button = document.getElementById('generateRouteBtn');
  if (selected.length > 0) {
    button.classList.add('show');
  } else {
    button.classList.remove('show');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
